import React, { useEffect, useState } from "react";
import { Container, Row, Col, Input, Spinner } from "reactstrap";
import coin from "../../assets/images/coin.webp";
import { Link } from "react-router-dom";
import { API_URL } from "../../config";
import { useFormik } from "formik";
import * as Yup from "yup";

const CurrencyList = () => {
  const [loading, setLoading] = useState(false);
  const [addressData, setAddressData] = useState([]);

  const fetchCurrency = async (filters = {}) => {
    try {
      setLoading(true);
      const resp = await fetch(API_URL + "/api/wallet/getCurrencyfilter", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: JSON.stringify({
          formvalue: {
            currency: filters.currrency_Name || "",
            symbol: filters.symbol || "",
            basecoin: filters.base_coin || "",
            status: filters.status || "",
            sortOption: "-1",
          },
        }),
      });

      const data = await resp.json();
      setAddressData(data?.getCurrencyTblDetails || []);
    } catch (error) {
      console.error("Error fetching currency list:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCurrency();
  }, []);

  const validation = useFormik({
    enableReinitialize: false,
    initialValues: {
      currrency_Name: "",
      symbol: "",
      base_coin: "",
      status: "",
    },
    validationSchema: Yup.object({
      currrency_Name: Yup.string().optional(),
      symbol: Yup.string().optional(),
      base_coin: Yup.string().optional(),
      status: Yup.string().optional(),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      await fetchCurrency(values);
      setSubmitting(false);
    },
  });

  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col>
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 font-size-18">Currency List</h4>
              <Link
                to={"/add-currency-list"}
                className="btn btn-primary btn-sm"
              >
                Add New Currency
              </Link>
            </div>
          </Col>
        </Row>

        <form onSubmit={validation.handleSubmit}>
          <div className="d-sm-flex align-items-center justify-content-between">
            <div className="r-g-4 d-flex gap-2">
              <div>
                <Input
                  type="text"
                  id="currrency_Name"
                  name="currrency_Name"
                  className="form-control"
                  placeholder="Currency Name"
                  value={validation.values.currrency_Name}
                  onChange={validation.handleChange}
                />
              </div>
              <div>
                <Input
                  type="text"
                  id="symbol"
                  name="symbol"
                  className="form-control"
                  placeholder="Symbol"
                  value={validation.values.symbol}
                  onChange={validation.handleChange}
                />
              </div>
              <div>
                <Input
                  type="text"
                  id="base_coin"
                  name="base_coin"
                  className="form-control"
                  placeholder="Base Coin"
                  value={validation.values.base_coin}
                  onChange={validation.handleChange}
                />
              </div>
              <div>
                <select
                  className="form-select"
                  name="status"
                  value={validation.values.status}
                  onChange={validation.handleChange}
                >
                  <option value="">Status</option>
                  <option value="1">Active</option>
                  <option value="0">Deactive</option>
                </select>
              </div>
              <button type="submit" className="btn btn-primary btn-sm">
                {loading ? <Spinner size="sm" /> : "Filter"}
              </button>
            </div>

            <div className="r-g-3">
              <button
                type="button"
                className="btn btn-primary btn-sm text-nowrap"
                onClick={() => {
                  if (!addressData || addressData.length === 0) {
                    alert("No data available to export");
                    return;
                  }

                  // CSV header
                  const header = "Currency Name,Symbol,Base Coin,Status\n";

                  // CSV rows
                  const csvData = addressData
                    .map(
                      (row) =>
                        `${row.currencyName || ""},${
                          row.currencySymbol || ""
                        },${row.basecoin || ""},${
                          row.status === 1 ? "Active" : "Inactive"
                        }`
                    )
                    .join("\n");

                  const blob = new Blob([header + csvData], {
                    type: "text/csv",
                  });
                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = "currency.csv";
                  a.click();
                  window.URL.revokeObjectURL(url); // cleanup
                }}
              >
                Export CSV
              </button>

              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={() => fetchCurrency()}
              >
                Refresh
              </button>
            </div>
          </div>
        </form>

        {/* Table */}
        <table className="table text-center mt-3">
          <thead>
            <tr>
              <th>Currency Name</th>
              <th>Symbol</th>
              <th>BaseCoin</th>
              <th>Image</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6">
                  <Spinner />
                </td>
              </tr>
            ) : addressData.length > 0 ? (
              addressData.map((address) => (
                <tr key={address?._id}>
                  <td>{address?.currencyName}</td>
                  <td>{address?.currencySymbol}</td>
                  <td>{address?.basecoin}</td>
                  <td>
                    <img
                      src={address?.image || coin}
                      alt="currency-img"
                      width={40}
                      height={40}
                    />
                  </td>
                  <td>
                    {address?.status === 0
                      ? "Deactive"
                      : address?.status === 1
                      ? "Active"
                      : address?.status === 2
                      ? "Rejected"
                      : "Processing"}
                  </td>

                  <td>
                    <Link
                      to={`/currency-list/${address?._id}`}
                      className="btn btn-primary btn-sm"
                    >
                      Edit
                    </Link>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6">No records found</td>
              </tr>
            )}
          </tbody>
        </table>
      </Container>
    </div>
  );
};

export default CurrencyList;
